import React, { useEffect, useState, useRef } from "react";
import LineIcon from '../../assets/images/dashboard/Line.svg';
import CalenderIcon from '../../assets/images/dashboard/calender.svg';
import ShieldIcon from '../../assets/images/dashboard/shield.svg';
import SearchIcon from '../../assets/images/dashboard/search.svg';
import { Button, DropdownList, Input } from "../../common/commonIndex";
import { Image } from "../componentIndex";
import LocationIcon from '../../assets/images/doctorProfile/map-marker.svg';
import WhiteLocationIcon from '../../assets/images/visits/white-map-marker.svg';
import InsuranceIcon from '../../assets/images/insurance.svg';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { format } from "date-fns";
import { useSearchParams } from "react-router-dom";




const SearchFilter = ({ onChange, isSearch, setIsSearch, queryParamData, className }) => {
    const [anywhere, setAnywhere] = useState('');
    const [nextAvailable, setNextAvailable] = useState();
    const [anyInsurance, setAnyInsurance] = useState('');
    const [isNear, setIsNear] = useState(false);
    const [isNextAvailable, setIsNextAvailable] = useState(false);
    const [isAnyInsurance, setIsAnyInsurance] = useState(false);
    const [mobile, setMobile] = useState(false);
    // const [isSearch, setIsSearch] = useState(isSearch || false);

    const [calenderValue, setCalenderValue] = useState([null], [null]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const datePickerRef = useRef(null);
    const dropdownMenuRef = useRef(false);
    const dropdownListRef = useRef(false);
    // { place: anywhere, lat: placeDetails.geometry.location.lat, lng: placeDetails.geometry.location.lng, startDate: startDateFr, endDate: endDateFr, insurance: anyInsurance }
    // const [state, setState] = useState({
    //     anywhere: queryParamData.place || '',
    //     nextAvailable: 
    //         queryParamData?.startDate && 
    //         queryParamData?.endDate &&
    //         !isNaN(new Date(queryParamData.startDate)) && 
    //         !isNaN(new Date(queryParamData.endDate))
    //             ? `${format(new Date(queryParamData.startDate), 'MMM dd')}-${format(new Date(queryParamData.endDate), 'dd')}`
    //             : '',
    //     anyInsurance: queryParamData.insurance || '',
    // }, [queryParamData]);

    const [state, setState] = useState({
        anywhere: '',
        nextAvailable: '',
        anyInsurance: '',
    });
    
    useEffect(() => {
        let getInsuranceProvider = JSON.parse(localStorage.getItem('insurance_provider'));
        let insuranceName;
        if(getInsuranceProvider?.length > 0) {
            if(queryParamData?.insId){
                insuranceName = getInsuranceProvider?.find(x => x.id === parseInt(queryParamData?.insId))?.name;
            }
        }
        setState({
            anywhere: queryParamData?.place || '',
            nextAvailable: 
                queryParamData?.startDate && 
                queryParamData?.endDate &&
                !isNaN(new Date(queryParamData?.startDate)) && 
                !isNaN(new Date(queryParamData?.endDate))
                    ? `${format(new Date(queryParamData.startDate), 'MMM dd')}-${format(new Date(queryParamData.endDate), 'dd')}`
                    : '',
            anyInsurance: insuranceName || queryParamData?.insurance || queryParamData?.insId || '',
        });
    }, [queryParamData]);


    const searchNearList = [
        { name: 'Bilbao, Spain' },
        { name: 'Birmingham, UK' },
        { name: 'Bihar, India' },
        { name: 'Bielefeld, Germany' },
        { name: 'Bilaspur, Chhattisgarh, India' }
    ];
    const insurances = [
        { name: 'Aetna' },
        { name: 'Ambetter' },
        { name: 'Benefit Planners' },
        { name: 'Blue Cross Blue Shield' },
        { name: 'Boon Chapman' },
        { name: 'California Physicians Service' },
        { name: 'Carefirst Inc.' },
        { name: 'Caresource' },
        { name: 'Cigna' },
        { name: 'CL Frateys' },
        { name: 'CVS Health' },
        { name: 'Elevance Health' },
        { name: 'Golden Rule' },
        { name: 'Government Employees Health Association (GEHA)' },
        { name: 'Guidewell Mutual Holding' },
        { name: 'Health Care Service Corporation(HCSC)' },
        { name: 'Health Net of California' },
        { name: 'HealthChoice' },
        { name: 'Highmark' },
        { name: 'Humana' },
        { name: 'Independence Health Group' },
        { name: 'Kaiser Permanente' },
        { name: 'Local lnitiative Health Authority' },
        { name: 'Mail Handlers' },
        { name: 'MedCost' },
        { name: 'Medicaid' },
        { name: 'Medicare' },
        { name: 'Metropolitan' },
        { name: 'Molina Healthcare' },
        { name: 'Oscar' },
        { name: 'Point32Health' },
        { name: 'Self Pay' },
        { name: 'Tricare' },
        { name: 'United Healthcar' },
        { name: 'UPMC Health System' },
        { name: 'Wellcare' },
        { name: 'WellFirst' },
    ];

    const handleButtonClick = () => {
        onChange();
    };

    const handleAnyWhereChange = (e) => {
        setAnywhere(e?.target?.value || '');
        setIsNear(!isNear);

        setState((prevState) => ({
            ...prevState,
            anywhere: e?.target?.value || '',
        }));
    };

    const handleNextAvailableChange = (e) => {
        setNextAvailable(e?.target?.value || '');
        setState((prevState) => ({
            ...prevState,
            nextAvailable: e?.target?.value || '',
        }));
        setIsNextAvailable(false);
    };

    const handleAnyInsuranceChange = (e) => {
        setAnyInsurance(e?.target?.value || '');
        setIsAnyInsurance(false);
        setState((prevState) => ({
            ...prevState,
            anyInsurance: e?.target?.value || '',
        }));
    };

    const handleSearch = (searchField) => {
        onChange();
        setIsSearch(!isSearch);
        if (searchField === 'nearMe') {
            setIsNear(true);
        }
        if (searchField === 'nextAvailabel') {
            setIsNextAvailable(true);
        }
        if (searchField === 'chooseInsurance') {
            setIsAnyInsurance(true);
        }

    }

    const handleEvent = () => {
        setIsNear(!isNear);
        setIsNextAvailable(false);
        setIsAnyInsurance(false);
    }

    const handleNextEvent = () => {
        setIsNextAvailable(!isNextAvailable);
        setIsNear(false);
        setIsAnyInsurance(false);
    }

    const handleAnyInsuranceEvent = () => {
        setIsAnyInsurance(!isAnyInsurance);
        setIsNextAvailable(false);
        setIsNear(false);
    }

    useEffect(() => {
        setMobile(window.innerWidth < 700);
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        
    }, []);

    const handleClickOutside = (event) => {
        if (
            dropdownMenuRef.current &&
            !dropdownMenuRef.current.contains(event.target)
        ) {

            setIsNear(false);

            if (isNextAvailable) {
                setIsNextAvailable(false);
            }

            if (isAnyInsurance) {
                setIsAnyInsurance(false);
            }

        }
        if (
            datePickerRef.current &&
            !datePickerRef.current.contains(event.target)
        ) {
            setIsNextAvailable(false);

            if (isNear) {
                setIsNear(false);
            }

            if (isAnyInsurance) {
                setIsAnyInsurance(false);
            }
        }
        if (
            dropdownListRef.current &&
            !dropdownListRef.current.contains(event.target)
        ) {
            setIsAnyInsurance(false);

            if (isNear) {
                setIsNear(false);
            }
            if (isNextAvailable) {
                setIsNextAvailable(false);
            }
        }
    };

    const today = new Date();
    // Memoize calenderOnChange to avoid creating a new instance on each render useCallback
    const calenderOnChange = (dates) => {
        const [start, end] = dates;
        const startDate = new Date(start);
        const endDate = new Date(end);
        const formattedRange = `${format(startDate, 'MMM dd')}-${format(endDate, 'dd')}`;
        setStartDate(start);
        setEndDate(end);
        setCalenderValue(dates);
        setNextAvailable(formattedRange);
        if(start && end){
            setIsNextAvailable(false);
        }
        setState((prevState) => ({
            ...prevState,
            nextAvailable: formattedRange || '',
        }));
    };


    const dayClassName = (date) => {
        const isToday =
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear();
        // Add class if date is before today and it's not today itself
        if (date < today && !isToday) {
            return 'disabled-before-today'; // Class for days before today
        }

        return ''; // No class for valid days and today itself
    };

    const handleSelect = (field, value) => {
        if (field === 'near me') {
            setState((prevState) => ({
                ...prevState,
                anywhere: value || '',
            }));
            setIsNear(false);
        } else if (field === 'insurance') {
            setState((prevState) => ({
                ...prevState,
                anyInsurance: value || '',
            }));
            setIsAnyInsurance(false);
        }


    }

    const isButtonDisabled = !anywhere || !nextAvailable || !anyInsurance;

    

    return (
        <>
            {
                isSearch ? (
                    <div className="header-search-filter" >
                        <div className="search-bar">
                            <div className="d-flex align-items-center">
                                <Image imgUrl={LineIcon} altText={'anywhere'} className={'anywhere'} />
                                <div className="dropdown search-Anywhere">
                                    <div className={`btn btn-secondary dropdown-toggle anywhere-input`} onClick={handleEvent} href="#" role="button" data-bs-toggle="dropdown" aria-expanded={isNear ? true : false}>
                                        <Input
                                            inputType="text"
                                            inputPlaceholder="Anywhere"
                                            className="form-control"
                                            value={state.anywhere}
                                            onChange={handleAnyWhereChange}
                                        />
                                    </div>
                                    {isNear && (
                                        <ul className={`dropdown-menu ${isNear ? 'active' : ''}`} ref={dropdownMenuRef}>
                                            <div className="scrollbar search-near-scrollbar">
                                                <div className="force-overflow">
                                                    {searchNearList?.length > 0 ? (
                                                        searchNearList.map((item, index) => (
                                                            <li onClick={() => handleSelect('near me', item.name)}>
                                                                <a key={index} className="dropdown-item" href="#" onClick={(e) => e.preventDefault()}>
                                                                    <Image imgUrl={LocationIcon} /> <span>{item.name}</span>
                                                                </a>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <p className="mb-0">No location in search criteria</p>
                                                    )}
                                                </div>
                                            </div>
                                        </ul>
                                    )}

                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <Image imgUrl={CalenderIcon} altText={'calendar'} className={'calendar-icon'} />

                                <div className="dropdown search-Anywhere">
                                    <div className={`btn btn-secondary dropdown-toggle `} onClick={handleNextEvent} href="#" role="button" data-bs-toggle="dropdown" aria-expanded={isNextAvailable ? true : false}>
                                        <Input
                                            inputType="text"
                                            inputPlaceholder="Next available"
                                            className="form-control"
                                            value={state.nextAvailable}
                                            onChange={handleNextAvailableChange}
                                        />
                                    </div>
                                    {isNextAvailable && (
                                        <div className={`dropdown-menu calendar-dropdown ${isNextAvailable ? 'active' : ''}`} ref={datePickerRef}>
                                        {/* <div className="scrollbar search-near-scrollbar">
                                            <div className="force-overflow"> */}
                                                    <div className="calendar-container">
                                                        <DatePicker
                                                            onChange={calenderOnChange}
                                                            selected={startDate}
                                                            inline
                                                            dayClassName={dayClassName}
                                                            calendarStartDay={0}
                                                            locale="it"
                                                            startDate={startDate}
                                                            endDate={endDate}
                                                            selectsRange
                                                            monthsShown={mobile ? 1 : 2} //
                                                            minDate={new Date()} // Disable past dates
                                                            disabledKeyboardNavigation
                                                        />
                                                    </div>
                                                {/* </div>
                                            </div> */}
                                        </div>
                                    )}

                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <Image imgUrl={ShieldIcon} altText={'insurance'} className={'shield-icon'} />
                                <div className="dropdown search-Anywhere" >
                                    <div className={`btn btn-secondary dropdown-toggle `} onClick={handleAnyInsuranceEvent}>
                                        <Input
                                            inputType="text"
                                            inputPlaceholder="Any insurance"
                                            className="form-control"
                                            value={state.anyInsurance}
                                            onChange={handleAnyInsuranceChange}
                                        />
                                    </div>
                                    {isAnyInsurance && (
                                        <ul className={`dropdown-menu ${isAnyInsurance ? 'active' : ''}`} ref={dropdownListRef}>
                                            <div className="scrollbar search-near-scrollbar">
                                                <div className="force-overflow">
                                                    {insurances?.length > 0 ? (
                                                        insurances.map((item, index) => (
                                                            <li onClick={() => handleSelect('insurance', item.name)}>
                                                                <DropdownList Icon={InsuranceIcon} item={item} index={index} />
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <p className="mb-0">No insurance provider in search criteria</p>
                                                    )}
                                                </div>
                                            </div>
                                        </ul>
                                    )}

                                </div>
                            </div>
                            <Button
                                btnClass="search-button header-search-btn"
                                btnType="button"
                                btnName=""
                                btnImage={SearchIcon}
                                btnImgAlt="Search"
                                btnImgCName="search-icon"
                                onClick={handleButtonClick}
                                isDisabled={true}
                            />
                        </div>
                    </div>
                ) : (
                    <div className={`searchable-data ${className}`}>
                        <div className="filter-data only-show-txt">
                            <div className="near-me d-flex align-items-center" onClick={() => handleSearch('nearMe')}><Image imgUrl={LineIcon} altText={'anywhere'} className={'anywhere pe-0'} /><p className={`text-nowrap overflow-hidden ${state.anywhere ? '' :'txt-placeholder' }`}>{state.anywhere ? state.anywhere : 'Near me'}</p></div>
                            <div className="next-availabel d-flex align-items-center" onClick={() => handleSearch('nextAvailabel')}><Image imgUrl={CalenderIcon} altText={'calendar'} className={'calendar-icon pe-0'} /><p className={`text-nowrap overflow-hidden ${state.nextAvailable ? '' :'txt-placeholder' }`}>{state.nextAvailable ? state.nextAvailable : 'Next available'}</p></div>
                            <div className="choose-insurance text-nowrap d-flex align-items-center" onClick={() => handleSearch('chooseInsurance')}><Image imgUrl={ShieldIcon} altText={'insurance'} className={'shield-icon pe-0'} /><p className={`text-nowrap overflow-hidden ${state.anyInsurance ? '' :'txt-placeholder' }`}>{state.anyInsurance ? state.anyInsurance : 'Any insurance'}</p></div>
                        </div>
                        <Button
                            btnClass="search-button btn-primary"
                            btnType="button"
                            btnName=""
                            btnImage={SearchIcon}
                            btnImgAlt="Search"
                            btnImgCName="search-icon"
                            onClick={handleButtonClick}
                            isDisabled={true}
                        />
                        {/* </div> */}
                    </div>
                )
            }
        </>

    )
};

export default SearchFilter;